module.exports = __webpack_public_path__ + "img/十门控制器 (2).5f9ce4bb.jpg";